module.exports = __webpack_public_path__ + "img/hr-branch-particle-18.f7dd71e5.png";